import React, { CSSProperties } from 'react';

const useBounceAnimation = (): [CSSProperties, ()=>void] => {
  const [isAnimated, setIsAnimated] = React.useState<boolean>(false);

  const style: CSSProperties = {
    display: 'inline-block',
    backfaceVisibility: 'hidden',
    transform: isAnimated
      ? 'scale(1.5)'
      : 'scale(1)',
    transition: 'transform ease-in-out 200ms',
  };

  React.useEffect(() => {
    if (!isAnimated) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsAnimated(false);
    }, 200);

    return () => {
      window.clearTimeout(timeoutId);
    }
  }, [isAnimated]);

  const trigger = React.useCallback(() => {
    setIsAnimated(true);
  }, []);

  return [style, trigger];
}

export default useBounceAnimation;
